import { getCateringData } from 'utils/cateringStorage'

// Catering action types
export const SAVE_CATERING_ADDRESS = 'SAVE_CATERING_ADDRESS'
export const UPDATE_CATERING_ADDRESS = 'UPDATE_CATERING_ADDRESS'
export const SET_CATERING_SCHEDULE = 'SET_CATERING_SCHEDULE'
export const CLEAR_CATERING_SCHEDULE = 'CLEAR_CATERING_SCHEDULE'
export const RESTORE_CATERING_DATA = 'RESTORE_CATERING_DATA'

// Action creators
export const saveCateringAddress = (address, store) => ({
    type: SAVE_CATERING_ADDRESS,
    payload: { address, store }
})

export const updateCateringAddress = (address, schedule, store) => ({
    type: UPDATE_CATERING_ADDRESS,
    payload: { address, schedule, store }
})

export const setCateringSchedule = (schedule) => ({
    type: SET_CATERING_SCHEDULE,
    payload: { schedule }
})

export const clearCateringSchedule = () => ({
    type: CLEAR_CATERING_SCHEDULE
})

// Get catering data from sessionStorage (synchronous action)
export const getCateringDataFromStorage = () => {
    return getCateringData()
}
